<template>  
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                    <ul>
                        <li class="item-link">
                            <router-link to="/loja" class="fa fa-home"></router-link>
                        </li>
                        <li class="item-link">
                            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
                        </li>
                        <li class="item-link">
                            <span>Consultar Estorno</span>
                        </li>
                    </ul>
            </div>
            <div class="container" id="list-estornos">
                <form @submit.prevent="frmConsulta" v-on:keyup.enter="ConsultarEstorno()" action="#" method="post" name="frm-billing" enctype="multipart/form-data">
                    <div class="row">
                        <div class="col-md-4">
                                        <FormHelper :inputVar="frmConsulta.statusEstorno"
                                                    :form="frmConsulta"                                      
                                                    type="select"
                                                    required="true"
                                                    label="Status do Estorno"
                                                    :options="getStatusEstorno()"                                                  
                                                    placeholder="Selecione o status do Estorno"></FormHelper>                                     
                        </div>                
                        <div class="col-md-3">
                            <FormHelper :inputVar="frmConsulta.dataInicial"
                                :value="dateInitDefault"
                                :form="frmConsulta"
                                validationType="pastDate2"
                                label="Data Inicial"
                                icon="fa-calendar"
                                type="picker"
                                mask="##/##/####"
                            ></FormHelper>
                        </div>
                        <div class="col-md-3">
                            <FormHelper :inputVar="frmConsulta.dataFinal"
                                :value="dateFinishDefault"
                                :form="frmConsulta"
                                validationType="pastDate2"
                                label="Data Final"
                                icon="fa-calendar"
                                type="picker"
                                mask="##/##/####"
                            ></FormHelper>
                        </div>
                        <div class="col-md-2 col-only-button">
                            <button aria-label="ConsultarEstorno" class="btn primary-button stretch"
                                v-on:click="ConsultarEstorno()">
                                Consultar Estornos
                            </button>        
                        </div>
                    </div> 
                    <div class="row" style="min-height: 300px; margin-top: 10px;">
                        <div class="col-xs-12">
                        <vue-good-table
                            :columns="columns"
                            :rows="registros"
                            :pagination-options="{
                                enabled: true,
                                mode: 'records',
                                perPage: 20,
                                position: 'top',
                                perPageDropdown: [40, 60],
                                dropdownAllowAll: true,
                                nextLabel: 'Próximo',
                                prevLabel: 'Anterior',
                                rowsPerPageLabel: 'Linhas por página',
                                ofLabel: 'de',
                                pageLabel: 'page',
                                allLabel: 'Todos',
                                }"
                            styleClass="vgt-table"
                        >
                            <template slot="table-row" slot-scope="props">
                            <span
                                v-if="props.column.field == 'estValor'"
                            >{{formatCurrency(props.formattedRow[props.column.field])}}</span>
                            <span v-else>{{props.formattedRow[props.column.field]}}</span>
                            </template>
                            <div slot="emptystate">Sem dados para exibição</div>
                        </vue-good-table>
                        </div>
                    </div>   
                </form>        
            </div>
        </div>
    </main>
</template>
<script>    
    import axios from 'axios';
    import "vue-good-table/dist/vue-good-table.css";
    import { VueGoodTable } from "vue-good-table";
    import FormHelper from "../../components/partials/FormHelper.vue";  

    export default {
        name: "ConsultarEstorno",
        data() { 
            return {
                formEstorno: {},
                frmConsulta:{
                    dataInicial: new this.formInput(false),
                    dataFinal: new this.formInput(false),
                    statusEstorno: new this.formInput(false),
                },
                columns: [
                    { label: "Código", field: "cliCodigo" },
                    { label: "Solicitante", field: "cliRazaosocial" },
                    { label: "Valor", field: "estValor" },
                    { label: "Status Estorno", field: "descricaoStatus" },
                    { label: "Motivo", field: "estDescricao" },
                ],
                registros: [],               
            }          
        },
        computed: {
            dateInitDefault: function () {
                return (this.frmConsulta.dataInicial.value = (this.frmConsulta.dataInicial.value ? this.frmConsulta.dataInicial.value : this.returnDate(30)));
            },
            dateFinishDefault: function () {
                var dtNow = new Date();
                return (this.frmConsulta.dataFinal.value = (this.frmConsulta.dataFinal.value ? this.frmConsulta.dataFinal.value : dtNow.toISOString()));
            }
        },
        mounted: function () {
            localStorage.currentStep = 0;
            const self = this;
            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning",
                    }).then(
                        () =>
                        (location.href =
                            `${self.$SiteUrl}/login?redirectTo=` + location.href)
                    );
                },
            });
            // self.ValidarParametros('HABILITAR_SOLICITACAO_ESTORNO_SITE');
            this.ConsultarEstorno();
        },
        components: {
            VueGoodTable,
            FormHelper
        },   
        methods: {             
            formInput: function (required, value) {
                // Define um padrão para estrutura de cada input do formulário
                this.required = required !== undefined ? required : true;
                this.value = value !== undefined ? value : "";

                this.validation = {
                    // Status é o inverso do requerido, pois se o input for obrigatório, ele inicia com o status inválido
                    // Para que o usuário seja barrado em caso de um submit sem dados
                    status: !this.required,
                    message: this.required ? "Por favor, preencha o campo acima" : ""
                };
            },
            formatCurrency: function (v) {
                v = v.toString().replace(",", ".");
                //formata valores floats para moeda
                var formato = {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "BRL",
                };
                return parseFloat(v).toLocaleString("pt-BR", formato);
            },
            getStatusEstorno: function () {
                const statusEstorno = [
                    {label: "Pendente Avaliação", value: 1},
                    {label: "Aguardando Pagamento", value: 2},
                    {label: "Cancelada", value: 3},
                    {label: "Paga", value: 4},
                    {label: "Todos"},
                ];
                return statusEstorno;
            },            
            ConsultarEstorno: function(){                 
                if(this.frmConsulta.dataInicial.value > this.frmConsulta.dataFinal.value){
                    return swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Data inicial não pode ser maior do que a Data Final',
                                icon: 'warning'
                            })
                }
                this.registros = []; 
                
                return axios({
                    method: "GET",
                    url: this.$apiUrlAPI + "Estorno/ConsultarEstorno",
                    headers: {"Content-Type": "application/json"},                    
                    params: {
                        'codigoCliente': JSON.parse(localStorage.getItem('usuarioLogado')).DadosCliente.CliCodigo, 
                        'dataInicial': this.frmConsulta.dataInicial.value,
                        'dataFinal': this.frmConsulta.dataFinal.value,
                        'statusSolicitacao': this.frmConsulta.statusEstorno.value.value
                    }
                }).then(response => {                      
                    if(response.status == 200){
                        if(response.data.length > 0)
                        {                           
                            this.registros = response.data;                           
                        }
                        else
                            this.HasNoData = true;
                    }
                    else
                    {
                        swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Não foi possível consultar as informações. Entre em contato com o administrador do sistema!',
                                icon: 'warning'
                        })
                    }           
                }).catch(function (error) {
                    console.log(error);
                    swal({
                                title: 'Erro ao Consultar dados!',
                                text: 'Não foi possível consultar as informações! Erro:' + error,
                                icon: 'warning'
                    })
                });
            },
            async ValidarParametros(parNome){                 
                await axios({
                    method: "GET",
                    url: this.$apiUrlAPI + "Parametros/Consultar",
                    headers: {"Content-Type": "application/json"},                    
                    params: {'nomeParametro': parNome}
                }).then(response => {  
                    if(response.status == 200){ 
                        if(response.data.parValor == "N")
                        {                                           
                            swal({
                                title: "Erro ao Carregar Página",
                                text: "Esta página não está habilitada para uso. Por favor, consulte o administrador do sistema!",
                                icon: "warning"
                            }).then(() => location.href = `${this.$SiteUrl}/loja/minha-conta`)                         
                        }
                    }                          
                }).catch(function (error) {
                    console.log(error);                
                });
            },
            formatDate: function (value) {
                var d = new Date(value);
                var datestring =
                    ("0" + d.getDate()).slice(-2) +
                    "/" +
                    ("0" + (d.getMonth() + 1)).slice(-2) +
                    "/" +
                    d.getFullYear();

                return datestring;
            },
            returnDate: function (time) {
                //função cria data baseado na quantidade de dias a mais ou a menos baseado na data atual
                var dt = new Date();
                var d = new Date(dt.setDate(dt.getDate() - time));
                //formata data para padrao dd/mm/yyyy
                var datestring =
                    ("0" + d.getDate()).slice(-2) +
                    "/" +
                    ("0" + (d.getMonth() + 1)).slice(-2) +
                    "/" +
                    d.getFullYear();
                return d.toISOString();
            },   
            search: function () {
                const self = this;
                this.frmConsulta.attemptSubmit = true;
                if (this.formErrors > 0) {
                    return;
                }
                var obj = {};
                obj.dataInicial = this.frmConsulta.dataInicial.value;
                obj.dataFinal = this.frmConsulta.dataFinal.value;
            }           
        }
    };
</script>